// src/utils/translationService.js

import axios from "axios";

export const translateText = async (
  text,
  sourceLang = "ro",
  targetLang = "en"
) => {
  if (!text?.trim()) return "";

  try {
    const response = await axios.post(
      `https://translation.googleapis.com/language/translate/v2?key=${process.env.REACT_APP_GOOGLE_TRANSLATION_KEY}`,
      {
        q: text,
        source: sourceLang,
        target: targetLang,
      }
    );
    return response.data.data.translations[0].translatedText;
  } catch (error) {
    console.error("Translation error:", error);
    throw error; // Re-throw to let components handle errors
  }
};
